import React from "react";

const NotFound = () => <div id="notfound"></div>;

export default NotFound;
